/**
 * V7.2 P0 FIX - Smart Index Route Redirect
 *
 * This component replaces the hard-coded "/dashboard" redirect on the index route.
 * It redirects users to their role-appropriate default route instead of always
 * sending everyone to /dashboard.
 *
 * Why this is needed:
 * - Sales Reps were landing on /dashboard (Admin workspace) and seeing blank pages
 * - The index route was unconditionally redirecting everyone to /dashboard
 * - This component uses getDefaultRoute() to send users to the correct workspace
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Loading from './Loading';

export default function DefaultRouteRedirect() {
  const { isLoading, getDefaultRoute } = useAuth();

  if (isLoading) {
    return <Loading />;
  }

  const defaultRoute = getDefaultRoute();
  return <Navigate to={defaultRoute} replace />;
}
